<template>
	<v-card outlined>
		<v-card-text class="pa-0">

		<div v-if="loading" class="url-preview rounded pa-3">
			<div v-if="small" class="d-flex flex-row w-100">
				<v-skeleton-loader
					width="200"
					height="150"
					type="image"
				></v-skeleton-loader>
				<div class="ml-2 w-100">
					<v-skeleton-loader
						type="paragraph"
					></v-skeleton-loader>
				</div>
			</div>
			<v-skeleton-loader
				v-else
				:type="'image, paragraph'"
			></v-skeleton-loader>
		</div>
		<div v-else-if="youtubeId">
			<video-player :youtube-id="youtubeId" :video="{url: url}" />
		</div>
		<div v-else @click="showLeave()" class="url-preview rounded lnk">
			<div v-if="!small">
				<v-img v-if="data.image" lazy-src="@/assets/images/image-placeholder.jpg" :src="data.image" max-height="300" class="mt-3 rounded"/>
				<div class="pa-3">
					<div v-if="data.site_name" class="font-16 bold mb-2">{{ data.site_name }}</div>
					<div v-if="data.title" class="url-title mb-2 bold ">{{ data.title }}</div>
					<div v-if="trimmedDescription" class="mt-3">
						{{ trimmedDescription }}
					</div>
					<div class="mt-3">
						<span class="text-muted font-12" @click="showLeave()">{{ trimmedUrl }}</span>
					</div>
				</div>
			</div>
			<div v-else >
				<div class="d-flex flex-row">
					<v-img v-if="data.image" :src="data.image" max-width="150" class="rounded mr-2"/>
					<div class="pa-3">
						<div v-if="data.site_name" class="font-16 bold mb-2">{{ data.site_name }}</div>
						<div v-if="data.title" class="url-title bold mb-2">{{ data.title }}</div>
						<div v-if="trimmedDescription" class="mt-3">
							{{ trimmedDescription }}
						</div>
						<div>
							<div class="text-muted font-12 mt-3" :href="url">{{ trimmedUrl }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</v-card-text>
		</v-card>
</template>

<script>
import axios from 'axios';
import VideoPlayer from '@/components/VideoPlayer'
export default {
	components: {
		VideoPlayer
	},
	props: {
		url: {
			type: String,
			required: true
		},
		small: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			loading: false,
			data: {
				site_name: null,
				title: null,
				description: null,
				image: null,
				type: null
			}
		}
	},
	computed: {
		youtubeId() {
			const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
			let match = this.url.match(regExp);
			return (match && match[7].length==11)? match[7] : false;
		},
		trimmedUrl() {
			if(this.url.length > 73) {
				return this.url.substr(0, 70) + '...';
			}
			return this.url;
		},
		trimmedDescription() {
			if(this.data.description) {
				if(this.data.description.length > 203) {
					return this.data.description.substr(0, 200) + '...';
				}
				return this.data.description;
			}
			return null;
		},
		isFriendly() {
			if(this.url.substring(0, window.location.origin.length) == window.location.origin) {
				return true;
			}
			return false;
		}
	},
	methods: {
		showLeave() {
			if(!this.isFriendly) {
				this.$store.commit('application/showLeave', this.url)
			}
			else {
				window.location.href = this.url;
			}
		},
		async getData() {
			this.loading = true;
			await axios.get('url-preview-sl', {
				params: {
					url: encodeURIComponent(this.url)
				}
			})
			.then(response => {
				this.data = response.data.data;
			})
			.catch(error => {
				console.log("ERROR OG", error)
			})
			setTimeout(() => {
				this.loading = false;
			}, 1000)

		}
	},
	created() {
		// console.log("IS YT", this.isYoutube())
		if(!this.youtubeId) {
			this.getData();
		}

	}
}
</script>

<style lang="scss">
.lnk {
			cursor: pointer;
		}
	.url-preview {

		position: relative;
		background: var(--v-grey-lighten2);

		&:hover {
			background: var(--v-grey-lighten3);
			transition: all ease 0.4s;
		}
		.url-image {
			height: 200px;
		}
	}
</style>
